import painter from './index.js';
import { fabric } from 'fabric';
export const SAVE_STATUS = {
    DELETE: 0,
    SAVE: 1
}
export default class GraphicBoardProxy {
    /**
     * instance
     * @type {GraphicBoardProxy}
     * @memberof GraphicBoardProxy
     */
    static _instance = null;

    /**
     *
     * @type {painter}
     * @memberof GraphicBoardProxy
     */
    currentPainter = null;
    /**
     *
     * @type {fabric.Group}
     * @memberof GraphicBoardProxy
     */
    currentBoard = null;

    /**
     * canvas
     * @type {fabric.Canvas}
     * @memberof GraphicBoardProxy
     */
    pageCanvas = null;

    graphicBoardSaves = new Map();

    static get Instance () {
        if(this._instance == null) {
            this._instance = new GraphicBoardProxy();
        }

        return this._instance;
    }
    /**
     * save painter of current graphic board
     * @param {string} key 
     */
    saveGraphicBoardPainter(key) {
        this.graphicBoardSaves.set(key, {status: SAVE_STATUS.SAVE, record: this.currentPainter.getSave()});
    }
    /**
     * set painter to delete
     * @param {string} key 
     */
    deleteGraphicBoardPainter(key) {
        if(this.graphicBoardSaves.has(key)) {
            const tempRecord = this.graphicBoardSaves.get(key).record;
            this.graphicBoardSaves.set(key, {status: SAVE_STATUS.DELETE, record: tempRecord});
        }
        
        this.pageCanvas.remove(this.currentBoard);
        this.pageCanvas.renderAll();
        this.currentPainter.addHistory();
    }
    recoverGraphicBoardPainter(key) {
        const tempRecord = this.graphicBoardSaves.get(key).record;
        this.graphicBoardSaves.set(key, {status: SAVE_STATUS.SAVE, record: tempRecord});
    }
    /**
     * get painter of current graphic board by key
     * @param {string} key 
     * @returns {json}
     */
    getGraphicBoardPainter(key) {
        console.log("get save::", key);
        if(this.graphicBoardSaves.has(key)) {
            return this.graphicBoardSaves.get(key).record;
        }else {
            return null;
        }
    }
    /**
     * set painter
     * @param {painter} painter 
     */
    setCurrentPainter(painter) {
        this.currentPainter = painter;
    }
    /**
     * set title
     * @param {string} title 
     */
    setTitle(title) {
        this.currentBoard.title = title;
        const objects = this.currentBoard.getObjects("text");
        console.log("set title::", objects);
        objects[0].set({
            "text": title
        });
        objects[0].set({
            left: -objects[0].getScaledWidth() * 0.5
        })

        console.log("current board::", this.currentBoard);
        this.pageCanvas.renderAll();
    }
    /**
     * get all graphic board record
     * @returns 
     */
    getGraphicBoardSave() {
        const self = this;
        let keys = Array.from(this.graphicBoardSaves.keys());

        return keys.map(key => {
            return {
                key: key,
                save: self.graphicBoardSaves.get(key).record
            };
        });
    }
    setGraphicBoardSave(saves) {
        const self = this;
        saves.forEach(value => {
            if (value.key && value.save) {
                self.graphicBoardSaves.set(value.key, {status: SAVE_STATUS.SAVE, record: value.save});
            }
        });
    }
    DeleteGraphicBoard() {

    }
}